import Alert from '@ramsey-design-system/alert';
import { InformationIcon } from '@ramsey-design-system/icons';
import Text from '@ramsey-design-system/text';

interface PhoneVerificationCountDownProps {
  phoneVerificationCountDown: number;
}

export function PhoneVerificationCountDownAlert({
  phoneVerificationCountDown
}: Readonly<PhoneVerificationCountDownProps>) {
  return (
    <Alert
      data-testid={'phone-verification-countdown-alert'}
      role={'alert'}
      className="mb-4"
      icon={InformationIcon}
    >
      <Text>
        If you need another code, you can try again in{' '}
        <b>
          {phoneVerificationCountDown +
            '\u00A0' +
            (phoneVerificationCountDown === 1 ? 'second' : 'seconds')}
        </b>
      </Text>
    </Alert>
  );
}
